import { Grid, Typography } from "@material-ui/core";
import React from "react";
import { useAppSelector } from "src/app-redux/hooks";
import { useStyles } from "./style";
import NoRecordFound from "src/components/NoRecordFound";
import moment from "moment";
import { selectYardTrail } from "src/app-redux/yard/yardSlice";

export interface IDrawerTrailProps {}

export default function DrawerTrail(props: IDrawerTrailProps) {
  const classes = useStyles();
  const colors = ["#BBC9DC", "#A5B9D6", "#839FC9", "#6A89B8"];

  // Redux
  const yardTrailObj: any = useAppSelector(selectYardTrail);
  return (
    <Grid container direction="row">
      <Grid
        item
        md={1}
        style={{
          borderBottomLeftRadius: yardTrailObj?.length > 1 ? "15px" : 0,
          borderLeft: yardTrailObj?.length > 1 ? "1px solid #D5DCE1" : "none",
          marginLeft: "10px",
          marginTop: "25px",
        }}
      ></Grid>
      <Grid
        item
        md={10}
        id="main-div"
        className={classes.drawerDetails}
        style={{
          marginLeft: "-48px",
          height: "max-content",
        }}
      >
        {yardTrailObj.length !== 0 ? (
          yardTrailObj.map((item: any, index: any) => (
            <>
              <Grid
                key={index}
                container
                spacing={2}
                className={
                  yardTrailObj.length !== 1 && index == yardTrailObj.length - 1
                    ? "topContainerTrailLastDiv"
                    : "topContainerTrail"
                }
              >
                <Grid container direction="row" className="itemRowTrail">
                  <Grid item md={1}>
                    {yardTrailObj.length == 1 || index != yardTrailObj.length - 1 ? (
                      <div
                        style={{
                          position: "relative",
                          zIndex: 0,
                          width: "20px",
                          height: "20px",
                          borderRadius: "50%",
                          backgroundColor: index < 3 ? colors[index] : "#6A89B8",
                        }}
                      >
                        <div
                          style={{
                            position: "relative",
                            zIndex: 0,
                            width: "12px",
                            height: "12px",
                            borderRadius: "50%",
                            border: "0.75px dashed #ffffff",
                            top: "4px",
                            left: "4px",
                          }}
                        ></div>
                      </div>
                    ) : (
                      <div></div>
                    )}
                  </Grid>
                  <Grid item md={11}>
                    <Typography className="subHeading">
                      Vehicle <b>{item.registrationNumber ? item.registrationNumber : "-"}</b>
                      {item.vehicleLeft ? " removed from " : " at "}
                      <b>
                        {" "}
                        {item.yardName ? item.yardName : "-"}, Row{" "}
                        {item.rowName ? item.rowName : "-"}, Slot{" "}
                        {item.columnOrder ? item.columnOrder : "-"}{" "}
                      </b>
                      at <b> {moment(new Date(item.entryTime)).format("hh:mm A DD/MM/YYYY ")}</b>
                      by
                      <b> {item.entryBy ? item.entryBy : "-"} </b>
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </>
          ))
        ) : (
          <div style={{ marginTop: "20px" }}>
            <NoRecordFound />
          </div>
        )}
      </Grid>
    </Grid>
  );
}
